<template>
  <div id="app">
    <receive-reward ref="receiveReward"></receive-reward>
    <!--<keep-alive>-->
      <!-- <router-view class="home-page" :class="{'hideLeft':$route.meta.serial>=1}" name="home"/>-->
      <router-view name='home' class="home-page"/>
    <!--</keep-alive>-->

    <transition :enter-active-class="enterAnim" :leave-active-class="leaveAnim">
      <router-view name="other" class="router-page"/>
    </transition>
    <transition :enter-active-class="enterAnim">
      <keep-alive>
        <router-view name="mocicle" class="router-page"/>
      </keep-alive>
    </transition>
    <!--<transition>-->
    <!--<router-view name="other" class="router-page"/>-->
    <!--</transition>-->

  </div>
</template>

<script>
  import ReceiveReward from './components/common/receive-reward';
  export default {
    name: 'app',
    components: {
      ReceiveReward
    },
    data() {
      return {
        enterAnim: '',
        leaveAnim: '',
      }
    },
    methods: {
    },

    created() {
      //分享页/任务推广页
      if(location.href.includes('/share')||(location.href.includes('/find')&&window.webkit||window.CallNative)){
        this.$utils.init();
        this.$http_data.init(this);
        this.$nav_util.init(this);
        this.$store.state.init(this);
        this.$router.push(location.href.split('#')[1]);
        return;
      }
      //分享邀请
      if(location.href.includes('/find/invite')){
        this.$utils.init();
        this.$http_data.init(this);
        this.$nav_util.init(this);
        this.$router.push(location.href.split('#')[1]);
        return;
      }   

      this.$config.init(this)
      this.$jiashuju.init(this)
      this.$websql.init(this);
      this.$http_data.init(this);
      this.$login_data.init(this);
      this.$device.init(this);
      this.$info.init(this);
      this.$socket.init(this);
      this.$handles.init(this);
      this.$store.state.init(this);
      this.$native.init(this);
      this.$utils.init()
      this.$nav_util.init(this);

      client.onNativeCall = this.$native.onNativeCall.bind(this.$native)

      this.$store.state.contact.init()
      this.$store.state.dialogues.init()


      if(!isNativeClient()){
        this.$store.commit('naveTo', {vue: this, path: this.$router_path.home})
      }else{
        // localStorage.setItem('guide', 'true');
        // this.$store.commit('naveTo', {vue: this, path: this.$router_path.GuidePage})
        // this.$store.commit('naveTo', {vue: this, path: this.$router_path.SelectLike})
        let tmpCallback = (obj)=>{
          if(obj.tmpGuide == ''){
            onJsCall({cmd: 'preference', type: "save", key: "tmpGuide", value: "true"});

            this.$store.commit('naveTo', {vue: this, path: this.$router_path.GuidePage})
          }else{
            this.$store.commit('naveTo', {vue: this, path: this.$router_path.home})
          }
        };
        this.$native.tmpCallback["tmpGuide"] = tmpCallback;
        onJsCall({cmd: 'preference', type: "get", key: "tmpGuide"});
      }


      let self = this
      //判断是pc还是移动端
      if (client.isClient) {
        self.$native.getLocation()
        onJsCall({cmd: 'client'}, function () {
          self.$login_data.tokenLogin()
        }, function () {
          self.$login_data.tokenLogin()
        })
      } else {
        self.$login_data.tokenLogin()
      }
    },
    mounted() {
      if (window.client.ios) {
        this.$store.state.showLeaveAnim = false
      }
      this.$store.state.showReceiveReward = (data)=>{
        this.$refs.receiveReward.add(data);
      };
    },
    watch: {
      "$route"(to, from) {
        // console.log(from)
        // console.log(to)
        // console.log(to.meta)

        if (from.path == this.$router_path.login && (this.$info.soaToken == null || this.$info.soaToken == "")) {
          if(to != null && (to.path == this.$router_path.register || to.path == this.$router_path.pwdReset)){

          }else{
            if(!this.$info.loginOK){
              this.$nav_util.goLogin()
            }
            return
          }
        }

        if (from.path == this.$router_path.home || to.path == this.$router_path.home) {
          this.enterAnim = ''
          this.leaveAnim = ''
          return
        }

        let from_index = 0;
        let to_index = 0;
        if (from.meta.serial) {
          from_index = from.meta.serial;
        }
        if (to.meta.serial) {
          to_index = to.meta.serial;
        }

        if (to_index != from_index) {
          let enter = false
          if (to_index > from_index) {
            enter = true
          }
          // console.log(enter + ' enter' + from_index + '   ' + to.meta.serial)


          this.enterAnim = enter ? "animated fadeInRight" : "animated fadeInLeft"
          this.leaveAnim = enter ? "animated fadeOutLeft" : "animated fadeOutRight"

          if (to_index == 1) {
            this.leaveAnim = "animated fadeOutRight"
          }

          if (!enter) {
            if (window.client.ios && !this.$store.state.showLeaveAnim) {
              this.enterAnim = ""
              this.leaveAnim = ""
            } else {
              if (window.client.ios) {
                this.$store.state.showLeaveAnim = false
              }
            }
          }
        }
      }
    }
  }
</script>

<!--公用样式-->
<style>
  @import "assets/css/base.css";
  /*阿里 font icon*/
  @import "assets/css/iconfont.css";
  /*过渡效果需要的动画库*/
  @import "assets/css/animate.css";
  /*weui 样式库*/
  @import "assets/css/weui.min.css";
  @import "assets/scss/app.css";
  @import "assets/css/face.css";
</style>



// WEBPACK FOOTER //
// src/App.vue